import React from 'react';
import { useTheme } from '@mui/material/styles';
import { PeekAccordion } from './PeekAccordion.js';
import { PeekAccordionDetails } from './PeekAccordionDetails.js';
import { PeekAccordionSummary } from './PeekAccordionSummary.js';
import { PeekDivider } from './PeekDivider.js';
import { PeekRadioLabel } from './PeekRadioLabel.js';
import { PeekTypography } from './PeekTypography.js';

const PeekAccordionCard = ({ expanded, onChange, label, disabled, summaryContent, detailsContent, withDivider, alwaysShowDetails = false, sx, }) => {
    const theme = useTheme();
    const summary = label != null ? (React.createElement(PeekRadioLabel, { isChecked: expanded, onClick: onChange, disabled: disabled, label: React.createElement(PeekTypography, { variant: "h4" }, label) })) : (summaryContent);
    return (React.createElement(PeekAccordion, { expanded: alwaysShowDetails || expanded, onChange: onChange, sx: Object.assign({ borderRadius: 2, boxShadow: `0px 1px 8px 2px ${theme.palette.grey[50]}`, border: "1px solid", borderColor: theme.palette.grey[100] }, sx) },
        React.createElement(PeekAccordionSummary, { expandIcon: null, "aria-controls": "accordion-content", id: "accordion-header", sx: {
                padding: 0,
                minHeight: 40,
                "> .MuiAccordionSummary-content": {
                    margin: 0,
                    marginLeft: 1,
                },
            } }, summary),
        detailsContent && (React.createElement(PeekAccordionDetails, { sx: {
                p: 0,
                pointerEvents: alwaysShowDetails || expanded ? "auto" : "none",
                opacity: alwaysShowDetails || expanded ? 1 : 0.7,
            } },
            withDivider && React.createElement(PeekDivider, { light: true }),
            detailsContent))));
};

export { PeekAccordionCard, PeekAccordionCard as default };
